
export const GOT_META_DATA_COUNT = 'GOT_META_DATA_COUNT_FOR_NEWSFEED_META_DATA';
export const UPDATE_PROPS = 'UPDATE_PROPS_NEWSFEED_META_DATA';






// WEBPACK FOOTER //
// ./src/app/stores/newsfeed/metaData/metaData-constants.js